import { Component, ElementRef } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams, RowNode } from 'ag-grid-community';

@Component({
	selector: 'cv-select-list-cell-renderer',
	templateUrl: './select-list-cell.renderer.html',
	styleUrls: ['./select-list-cell.renderer.scss']
})
export class SelectListCellRenderer implements AgRendererComponent {

	public params: ICellRendererParams;
	public rowData: any;
	public fieldId: string;
	public fieldName: string;
	public listItems: Array<any>;
	public selectedItem: any;
	public scrollableArea: any;

	constructor(public elementRef: ElementRef) {
		this.listItems = [];
	}

	/**
	 * On Cell Init.
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.params = params;
		this.rowData = this.params.data;
		this.listItems = this.params['listItems'];
		if (params['fieldId']) {
			this.fieldId = this.params['fieldId'];
			this.fieldName = this.params['fieldName'];
			if (this.rowData[this.fieldId]) {
				const match = this.listItems
					.find(item => item.id === this.rowData[this.fieldId]);
				if (match) {
					this.selectedItem = match;
				}
			}
		}
		this.elementRef.nativeElement.querySelector('cv-dropdown .__select')
			.addEventListener('click', this.scrollIntoDropdown);
		this.scrollableArea = this.elementRef.nativeElement.closest('.ag-body-viewport');
	}

	/**
	 * On Cell Refresh
	 * @param params
	 */
	refresh(params: any): boolean {
		return true;
	}

	/**
	 * On select item change
	 * @param $event
	 */
	onValueChange($event: any): void {
		const newData = {[this.fieldId]: null, [this.fieldName]: null};
		if ($event) {
			newData[this.fieldId] = $event.id;
			newData[this.fieldName] = $event.name;
		}
		this.params.context.parentComponent.onCellUpdated(this.params, newData);
	}

	/**
	 * On Select List opened event
	 */
	onSelectListOpen(): void {
		setTimeout( () => {
			this.params.context.parentComponent.expandRow(this.params.node);
		}, 100);
	}

	/**
	 * On Select List closed event
	 */
	onSelectListClose(): void {
		const expandedRow: RowNode = this.params.context.parentComponent.getExpandedRow();
		if (expandedRow && expandedRow.rowIndex === this.params.node.rowIndex) {
			this.params.context.parentComponent.collapseRowWithDelay(this.params.node);
		}
	}

	/**
	 * Determines if we should scroll into the dropdown since it can be override
	 * @param timeout: milliseconds
	 */
	scrollIntoDropdown = (): void => {
		setTimeout(() => {
			this.elementRef.nativeElement.scrollIntoView({ behavior: 'smooth' });
		}, 200);
	}
}
